import { render, staticRenderFns } from "./Medicos.vue?vue&type=template&id=be3ed116&"
import script from "./Medicos.vue?vue&type=script&lang=js&"
export * from "./Medicos.vue?vue&type=script&lang=js&"
import style0 from "./Medicos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports